import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "step-header" }
const _hoisted_2 = { class: "point-content" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Wunschkennzeichen", -1)
const _hoisted_5 = { class: "point-content" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Halterdaten", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "point-content" }, "3", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Zahlung", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]




export default /*#__PURE__*/_defineComponent({
  props: {
  Step: { type: Number, required: true },
},
  emits: ["GoBack"],
  setup(__props, { emit: Emits }: { emit: ({
  (e: 'GoBack', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const Props = __props




const GoBack = (TargetStep: number) => {
  if (Props.Step > TargetStep) {
    Emits('GoBack', TargetStep);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["point", { done: __props.Step > 1, active: __props.Step == 1 }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (GoBack(1)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.Step > 1)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              style: { color: '#fff' },
              icon: ['fas', 'check']
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "1"))
      ]),
      _hoisted_4
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["line", { done: __props.Step > 1 }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["point", { done: __props.Step > 2, active: __props.Step == 2 }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (GoBack(2)))
    }, [
      _createElementVNode("div", _hoisted_5, [
        (__props.Step > 2)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              style: { color: '#fff' },
              icon: ['fas', 'check']
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "2"))
      ]),
      _hoisted_7
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["line", { done: __props.Step > 2 }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["point", { done: __props.Step > 3, active: __props.Step == 3 }])
    }, _hoisted_10, 2)
  ]))
}
}

})